import { render } from "./carruselcomponent2.vue?vue&type=template&id=1fbb975c&scoped=true"
import script from "./carruselcomponent2.vue?vue&type=script&lang=js"
export * from "./carruselcomponent2.vue?vue&type=script&lang=js"

import "./carruselcomponent2.vue?vue&type=style&index=0&id=1fbb975c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbb975c"]])

export default __exports__